// export * from './user';

import { FormatRegistry, type TSchema } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { validation } from './_common/validation.js';

const defineValidationFormats = () => {
  FormatRegistry.Set('mobile', validation.mobile);
  FormatRegistry.Set('email', validation.email);
  FormatRegistry.Set('uuid', validation.uuid);
  FormatRegistry.Set('color', validation.color);
  FormatRegistry.Set('ledColor', validation.ledColor);
  FormatRegistry.Set('cnpj', validation.cnpj);
  FormatRegistry.Set('cep', validation.cep);
  FormatRegistry.Set('fullname', validation.fullname);
  FormatRegistry.Set('password', validation.password);
};

defineValidationFormats();

export function validateField<T extends TSchema>(
  schema: T,
  field: string,
  value: unknown,
  context: Record<string, unknown> = {}
): string | true {
  const parts = field.split('.');
  const structuredValue = parts.reduceRight((acc, key) => ({ [key]: acc }), value);
  const merged = { ...context, ...(structuredValue as Record<string, unknown>) };

  const fieldPath = '/' + parts.join('/');
  const errors = Array.from(Value.Errors(schema, merged));

  // Quando o TypeBox não consegue casar nenhum branch do union
  const onlyUnionError =
    errors.length === 1 && errors[0].message === 'Expected union value' && errors[0].errors?.length > 0;

  if (onlyUnionError) {
    // tenta achar erro apenas no branch compatível com os dados
    for (const branch of errors[0].errors) {
      const nestedErrors = Array.from(branch);
      for (const err of nestedErrors) {
        if (err.path === fieldPath || fieldPath.startsWith(err.path + '/') || err.path?.startsWith(fieldPath + '/')) {
          return err.schema?.error ?? err.message ?? 'Campo inválido';
        }
      }
    }
    return true; // ignora se nenhum erro de campo foi achado
  }

  // Erros normais (fora do union root)
  for (const err of errors) {
    if (err.path === fieldPath || fieldPath.startsWith(err.path + '/') || err.path?.startsWith(fieldPath + '/')) {
      return err.schema?.error ?? err.message ?? 'Campo inválido';
    }
  }

  return true;
}

export function checkInput<T extends TSchema>(schema: T, value: unknown): Record<string, string> {
  return Array.from(Value.Errors(schema, value)).reduce(
    (acc, err) => {
      const key = err.path.slice(1); // remove '/'
      if (key) acc[key] = err.message;
      return acc;
    },
    {} as Record<string, string>
  );
}
